"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _Radio = _interopRequireDefault(require("@cimpress/react-components/lib/Radio"));

var _RadioGroup = _interopRequireDefault(require("@cimpress/react-components/lib/RadioGroup"));

var _Select = _interopRequireDefault(require("@cimpress/react-components/lib/Select"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

function setDefaultIdentityType(props) {
  // If the identity type hasn't been set, force it the default value.
  // This guarantees that the radio group will have a value selected.
  var identityId = props.identityId,
      fulfillerOrder = props.fulfillerOrder,
      merchantOrder = props.merchantOrder,
      onChange = props.onChange;
  var defaultIdentityType = 'fulfillers';

  if (!fulfillerOrder.length && merchantOrder.length) {
    defaultIdentityType = 'merchants';
  }

  onChange && onChange(defaultIdentityType, identityId);
}

var UserIdentityModalSelect =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UserIdentityModalSelect, _React$Component);

  function UserIdentityModalSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserIdentityModalSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserIdentityModalSelect).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      fulfillers: [],
      merchants: []
    };
    return _this;
  }

  (0, _createClass2.default)(UserIdentityModalSelect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      setDefaultIdentityType(this.props);
      this.formatIdentities(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      var identitiesChanged = this.props.fulfillers !== props.fulfillers || this.props.fulfillerOrder !== props.fulfillerOrder || this.props.merchants !== props.merchants || this.props.merchantOrder !== props.merchantOrder;

      if (identitiesChanged) {
        setDefaultIdentityType(props);
        this.formatIdentities(props);
      }
    }
  }, {
    key: "onChangeIdentityType",
    value: function onChangeIdentityType(event, selection) {
      // Changing the identity type forces the identity ID to be set to null if the new identity type
      //   is different from the previous identity type because the identity ID was only valid for the
      //   last selection.
      var _this$props = this.props,
          identityId = _this$props.identityId,
          identityType = _this$props.identityType,
          onChange = _this$props.onChange;
      onChange && onChange(selection, identityType === selection ? identityId : null);
    }
  }, {
    key: "onChangeIdentityId",
    value: function onChangeIdentityId(event) {
      // The event argument is null when the react-select component has the selection cleared, so that
      //   needs to be handled separately.
      var _this$props2 = this.props,
          identityType = _this$props2.identityType,
          onChange = _this$props2.onChange;
      onChange && onChange(identityType, event && event.value);
    }
  }, {
    key: "formatIdentities",
    value: function formatIdentities(props) {
      // Format the fulfiller and merchant lists into something usable by the Select component.
      // This only runs when one or more of the four required props have changed to prevent needless
      //   and possibly expensive recomputation of these new lists.
      var fulfillers = props.fulfillers,
          fulfillerOrder = props.fulfillerOrder,
          merchants = props.merchants,
          merchantOrder = props.merchantOrder;
      var newFulfillers = fulfillerOrder.map(function (id) {
        var fulfiller = fulfillers[id];
        return {
          label: fulfiller && fulfiller.name,
          value: id
        };
      });
      var newMerchants = merchantOrder.map(function (id) {
        var merchant = merchants[id];
        return {
          label: merchant && merchant.name,
          value: id
        };
      });
      this.setState({
        fulfillers: newFulfillers,
        merchants: newMerchants
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          identityId = _this$props3.identityId,
          identityType = _this$props3.identityType;
      var _this$state = this.state,
          fulfillers = _this$state.fulfillers,
          merchants = _this$state.merchants;
      var singleSelect = fulfillers.length === 0 || merchants.length === 0;

      var identityTypeSelect = _react.default.createElement(_RadioGroup.default, {
        valueSelected: identityType,
        inline: true,
        name: "Tenant type",
        onChange: this.onChangeIdentityType
      }, _react.default.createElement(_Radio.default, {
        value: "fulfillers",
        label: "Fulfiller"
      }), _react.default.createElement(_Radio.default, {
        value: "merchants",
        label: "Merchant"
      }));

      var identityOptions = {
        fulfillers: fulfillers,
        merchants: merchants
      }[identityType];

      var identitySelect = _react.default.createElement(_Select.default, {
        label: "Identity",
        options: identityOptions,
        value: identityId,
        onChange: this.onChangeIdentityId
      });

      return _react.default.createElement("div", null, singleSelect ? null : identityTypeSelect, identitySelect);
    }
  }]);
  return UserIdentityModalSelect;
}(_react.default.Component);

var _default = UserIdentityModalSelect;
exports.default = _default;